import request from "@src/utils/request";
import type {
  Notification,
  NotificationSettings,
  PaginatedResponse,
} from "@src/types/notification";

interface NotificationFilters {
  isRead?: boolean;
  page?: number;
  pageSize?: number;
}

/**
 * API client for notification endpoints
 *
 * Endpoints:
 * - GET /api/v1/notifications/ - List user's notifications (paginated)
 * - PATCH /api/v1/notifications/<id>/mark-read/ - Mark notification as read
 * - PATCH /api/v1/notifications/mark-all-read/ - Mark all notifications as read
 * - GET /api/v1/current-user/notification-settings/ - Get user's notification preferences
 * - PATCH /api/v1/current-user/notification-settings/ - Batch update notification preferences (array)
 */

export function getNotifications(filters: NotificationFilters = {}) {
  return request().query(filters).get("/api/v1/notifications/").send();
}

export function markAsRead(notificationId: string) {
  return request()
    .patch(`/api/v1/notifications/${notificationId}/mark-read/`)
    .send();
}

export function markAllAsRead() {
  return request().patch("/api/v1/notifications/mark-all-read/").send();
}

export function getNotificationSettings() {
  return request().get("/api/v1/current-user/notification-settings/").send();
}

/**
 * Update notification settings (batch update)
 * Accepts an array of settings to update
 */
export function updateNotificationSettings(
  settings: Array<Partial<NotificationSettings> & { id: string }>,
) {
  return request()
    .patch("/api/v1/current-user/notification-settings/")
    .send(settings);
}
